import React, { useState } from "react";
import { supportedLanguages } from "../../../constants";
import BarekamInput from "../input";
import { useAppSelector } from "../../../redux/store";
import { MessageSections } from "../message/message";
import { getMessage } from "../../shared/helper-functions";
import { Grid } from "@mui/material";

const BarekamInputMultilingual = ({
  multilingualText,
  labelKey,
  field,
  onChange,
  errors,
  messageSection = MessageSections.MAIN,
}: BarekamInputMultilingualProps) => {
  const [text, setText] = useState<{ [key: number]: string }>(
    multilingualText || {},
  );
  const { messageCache, languageId } = useAppSelector(
    (state) => state.messagesReducer,
  );

  function handleChange(languageId: number, value: string) {
    const textClone = { ...text };
    textClone[languageId] = value;

    setText(textClone);

    onChange(textClone);
  }

  return (
    <>
      {supportedLanguages.map((abbr, index) => (
        <Grid item xs={12} key={index}>
          <BarekamInput
            key={`${labelKey}-input-${abbr}`}
            customInputVariant={"standard"}
            placeholder={getMessage(
              `${labelKey}_${abbr}`,
              MessageSections.LOGIN,
              messageCache,
              languageId,
            )}
            value={text[index + 1]}
            onChange={(value) => handleChange(index + 1, value.target.value)}
            error={!!errors[field]}
            errorMessage={
              errors[field] &&
              getMessage(
                errors[field],
                messageSection,
                messageCache,
                languageId,
              )
            }
            width={"100%"}
            required
          />
        </Grid>
      ))}
    </>
  );
};

export default BarekamInputMultilingual;

interface BarekamInputMultilingualProps {
  multilingualText: { [key: number]: string };
  labelKey: string;
  field: string;
  onChange: (value: any) => void;
  errors: { [key: string]: string };
  messageSection?: MessageSections;
}
